"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BronsonMegaMenuDropdown = void 0;
const React = require("react");
const react_1 = require("react");
const megamenu_link_1 = require("./megamenu-link");
const megamenu_levels_enum_1 = require("./megamenu-levels.enum");
const constants_1 = require("../../utils/constants");
const BronsonMegaMenuDropdown = (props) => {
    const listRef = (0, react_1.useRef)(null);
    return (React.createElement("li", null,
        React.createElement("button", { title: `Ir a ${props.menuLabel}`, className: `c-mega-menu__link c-mega-menu__link--level-${props.level} u-text-left`, "data-component": 'dh-megamenu-dropdown-button', onClick: () => props.onOpenMenu &&
                props.onOpenMenu(props.level, props.id, listRef) },
            React.createElement("span", { className: 'o-media o-media--small o-media--middle' },
                props.img ? (React.createElement("span", { className: 'o-media__img' },
                    React.createElement("i", { className: `c-mega-menu__icon c-icon c-icon--small c-icon--[${props.img}]` }))) : (''),
                React.createElement("span", { className: 'o-media__body' },
                    props.menuLabel,
                    React.createElement("span", { className: 'c-mega-menu__arrow' })))),
        React.createElement("ul", { id: `list${props.id}`, ref: listRef, className: `c-mega-menu__list c-mega-menu__list--level-${props.listLevel} 
                ${props.openLevels &&
                props.listLevel &&
                props.currentId &&
                props.openLevels[props.listLevel] &&
                props.currentId.indexOf(props.id) === constants_1.zero
                ? 'is-open-on-desktop is-open-on-mobile'
                : ''}` }, props.routes.map((route, index) => {
            if (props.userRole &&
                (!route.allowedRoles ||
                    route.allowedRoles.includes(props.userRole))) {
                if (route.siblings) {
                    return (React.createElement(exports.BronsonMegaMenuDropdown, { key: index, id: `${props.id}-${index}`, userRole: props.userRole, routes: route.siblings, menuLabel: route.label, img: route.img, onOpenMenu: props.onOpenMenu, level: props.listLevel, listLevel: megamenu_levels_enum_1.Levels.THREE, openLevels: props.openLevels, currentId: props.currentId }));
                }
                else {
                    return (React.createElement(megamenu_link_1.BronsonMegaMenuLink, { key: index, route: route, level: props.listLevel, onCloseMenu: props.onCloseMenu }));
                }
            }
        }))));
};
exports.BronsonMegaMenuDropdown = BronsonMegaMenuDropdown;
